export default __webpack_public_path__ + "static/intro-walkthrough-1a5a49d3c11c14f3603bd2f3dbcf03a8.mp4";